import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Toggle from 'material-ui/Toggle'
import { renderAlert } from '../../../services/render-alert'
import fetchApi from '../../../services/fetchApi'
import css from './patientCard.css'

const labelStyles = {
  fontWeight: '400',
}

class RemindersOptToggle extends Component {
  static propTypes = {
    patient: PropTypes.object,
    isCloud9: PropTypes.bool,
    useCorrespondenceValues: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    const {
      patient: { opt_in_email_apt_remind, opt_in_text_apt_remind },
    } = this.props
    this.state = {
      emailRemind: opt_in_email_apt_remind,
      textRemind: opt_in_text_apt_remind,
    }
  }

  updatePatient = (reminderType) => {
    const { patient: { id } } = this.props
    const oldValue = this.state[reminderType]
    const fieldToUpdate = reminderType === 'textRemind'
      ? 'opt_in_text_apt_remind'
      : 'opt_in_email_apt_remind'
    const updatedPatientInfo = {}
    updatedPatientInfo[fieldToUpdate] = `${!oldValue}`
    const requestBody = { body: JSON.stringify(updatedPatientInfo) }
    fetchApi(`/patients/${id}`, 'PATCH', requestBody)
      .then((res) => {
        if (res.error) {
          renderAlert(res.error, 'error')
        } else {
          this.setState({ [reminderType]: res[fieldToUpdate] })
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  render() {
    const { emailRemind, textRemind } = this.state
    const { isCloud9, useCorrespondenceValues } = this.props
    return (
      <div className={css.RemindersOptToggleContainer}>
        <div className={css.horizontalLine} />
        <span className={css.label}>
          {isCloud9 && useCorrespondenceValues
            ? 'Reminders Preference (set in Cloud9)'
            : 'Reminders Preference'}
        </span>
        <div className={css.toggleBox}>
          <Toggle
            label="Receive Text Reminders"
            toggled={textRemind}
            onToggle={() => this.updatePatient('textRemind')}
            labelStyle={labelStyles}
            disabled={isCloud9 && useCorrespondenceValues}
          />
          <Toggle
            label="Receive Email Reminders"
            toggled={emailRemind}
            onToggle={() => this.updatePatient('emailRemind')}
            labelStyle={labelStyles}
            disabled={isCloud9 && useCorrespondenceValues}
          />
        </div>
      </div>
    )
  }
}

export default RemindersOptToggle



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/RemindersOptToggle.js